import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import ChannelsMenu from './components/ChannelsMenu';
import ChatLayout from './components/ChatLayout';
import { useGlobalState } from './state';

import './App.scss';
import { getSocketCliet, MESSAGE_LIST_TOPIC, getUserUnreadMessageTopic, SUMMARY_VOTES, workspaceLoaded } from './api';
import SocketClientContext from './contexts/SocketClient';
import { groupMessagesByChannel } from './util';
import UserNameModal, { USER_NAME_STORAGE_KEY } from './components/UserNameModal';
import { registerForPushNotifications } from './push';

const { Sider, Content } = Layout;

const DOCUMENT_TITLE = document.title;

function App() {
  const [, setMessagesByChannel] = useGlobalState('messagesByChannel');
  const [socketClient, setSocketClient] = useState(null);
  const [unreadCountByChannel, setUnreadCountByChannel] = useGlobalState('unreadCountByChannel');
  const [, setSummaryVotesById] = useGlobalState('summaryVotesById');

  useEffect(() => {
    const unreadCount = Object.keys(unreadCountByChannel)
      .map(channel => unreadCountByChannel[channel])
      .reduce((total, count) => total + count, 0);
    document.title = unreadCount > 0 ? `(${unreadCount}) ${DOCUMENT_TITLE}` : DOCUMENT_TITLE;
  }, [unreadCountByChannel]);

  useEffect(() => {
    const client = getSocketCliet();

    client.connect({}, () => {
      client.subscribe(MESSAGE_LIST_TOPIC, ({ body }) => {
        const messages = JSON.parse(body)
        const byChannel = groupMessagesByChannel(messages);
        setMessagesByChannel(byChannel);
      });

      // only subcribe if the username is set already, otherwise it's subscribed in UserNameModal
      if (localStorage.getItem(USER_NAME_STORAGE_KEY)) {
        client.subscribe(getUserUnreadMessageTopic(), ({ body }) => {
          const unread = JSON.parse(body)
          setUnreadCountByChannel(unread);
        });
        registerForPushNotifications();
      }

      client.subscribe(SUMMARY_VOTES, ({ body }) => {
        const votes = JSON.parse(body)
        console.log('VOTES', votes);
        setSummaryVotesById(votes);
      });

      setSocketClient(client);
    });

    workspaceLoaded();


    setSocketClient(client);
  }, [setMessagesByChannel, setUnreadCountByChannel, setSummaryVotesById]);

  return (
    <SocketClientContext.Provider value={socketClient}>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider breakpoint="xs" collapsedWidth={0}>
          <ChannelsMenu />
        </Sider>
        <Content style={{ maxHeight: '100vh' /* to allow only scroll here */ }}>
          <ChatLayout />
        </Content>
      </Layout>
      <UserNameModal />
    </SocketClientContext.Provider>
  );
}

export default App;
